import { config } from '@littlebird/sdk';
import { isOpenableUrl, isTrustedUrl } from '@littlebird/ui-utils';

import { ExternalLinkModal } from '@/components/modals/ExternalLinkModal';
import { ModalsManager } from '@/components/modals/modalsManager';

import { handleExternalUrlClick } from './platform';

export function openUntrustedUrl(url: string): void {
  if (!isOpenableUrl(url)) return;

  if (isTrustedUrl(url) || !config.chat.confirm_external_links) {
    handleExternalUrlClick(url);
    return;
  }

  ModalsManager.show(ExternalLinkModal, { url });
}
